
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stats",
      function () {
        return require("private-next-pages/stats.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stats"])
      });
    }
  